import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryontwoseater() {



  const cardData =
  {
    keyword: 'Luxury 12,14,17 Seater Tempo Traveller in Pune ',
    heading: 'Sanavi Travels: Luxury 12,14,17 Seater Tempo Traveller in Pune',
    headingDescription: 'Sanavi Travels offers reliable Luxury 12, 14, 17 Seater Tempo Traveller in Pune, providing premium, comfortable, and hassle-free travel solutions for families, corporate teams, wedding guests, tourists, and group travelers within Pune and for outstation journeys. Our fleet of luxury tempo travellers with 12, 14, and 17 seating capacity is equipped with push-back leather seats, ample legroom, powerful air-conditioning, ambient lighting, charging points, music systems, and generous luggage space to ensure a superior travel experience. With professional chauffeurs, flexible local and outstation rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual service and smooth journeys. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering destinations such as Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, Konkan, and other popular routes. Choose Sanavi Travels for trusted luxury 12, 14, 17 seater tempo traveller rental services in Pune, delivering comfort, safety, and a premium group travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical monument and a symbol of Maratha pride. Once the seat of Peshwa Bajirao I’s administration, the fort features massive stone walls, majestic gateways like the Delhi Darwaza, and well-laid gardens. Although much of it was destroyed in a fire, the remaining structures still reflect royal grandeur. The evening light-and-sound show brings Maratha history alive. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is a landmark closely associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it functions as a museum displaying photographs, personal belongings, and historical documents. The palace is surrounded by lush gardens and features elegant Italian arches. It symbolizes sacrifice, peace, and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual site, dedicated to Lord Ganesha. The beautifully adorned idol attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the center of grand celebrations and cultural festivities. The trust is also well known for its charitable initiatives. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress known for the legendary sacrifice of Tanaji Malusare in 1670 for Chhatrapati Shivaji Maharaj. Located atop a steep hill, the fort offers panoramic views of the Sahyadri ranges. Visitors can trek or drive to explore its gates, memorials, and viewpoints. Sinhagad perfectly blends history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in the busy city center, the temple offers a calm and meditative atmosphere. Monolithic pillars and ancient carvings showcase early Indian craftsmanship. It is one of Pune’s finest hidden heritage sites."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses an extraordinary collection of over 20,000 artifacts representing India’s rich cultural heritage. The exhibits include traditional musical instruments, sculptures, household items, and ornaments. The recreated Mastani Mahal is a major highlight. The museum is a must-visit for history, art, and culture enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering breathtaking panoramic views of the city. After climbing 103 stone steps, visitors reach the Parvati Temple complex built during the Peshwa era. Smaller shrines and a museum enhance the experience. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from around the world. The ashram offers meditation programs, wellness therapies, and mindfulness sessions in a serene environment. Beautifully landscaped gardens add to its peaceful ambiance. Osho Ashram is Pune’s international center for relaxation and self-discovery."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. Flowing streams, arched bridges, and lush lawns create a tranquil setting. It is a favorite spot for families, walkers, and photographers. The garden offers a refreshing escape from city life."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure spot near Pune, especially during monsoon and evenings. The vast reservoir, cool breeze, and surrounding hills create a scenic atmosphere. Street food stalls add to the charm. It also serves as the gateway to Sinhagad Fort, making it a perfect short getaway."
  }
]
,




"services": [
  {
    "name": "Luxury 12 Seater Tempo Traveller Pune",
    "description": "Luxury 12 Seater Tempo Traveller Pune offers premium travel solutions for small groups seeking comfort and style. The vehicle features plush seating, spacious interiors, air-conditioning, and ample luggage space, making it ideal for family outings, corporate trips, and tourist travel. Professional chauffeurs ensure safe driving and smooth journeys within Pune or for outstation travel."
  },
  {
    "name": "Luxury 14 Seater Tempo Traveller Pune",
    "description": "Luxury 14 Seater Tempo Traveller Pune provides a perfect balance of space and comfort for medium-sized groups. Designed with luxury interiors, comfortable seats, and modern amenities, this option is suitable for family tours, group sightseeing, and corporate travel. Experienced drivers ensure punctual and stress-free journeys."
  },
  {
    "name": "Luxury 17 Seater Tempo Traveller Pune",
    "description": "Luxury 17 Seater Tempo Traveller Pune is ideal for larger groups looking for premium travel comfort. With spacious seating, elegant interiors, and smooth suspension, it ensures a relaxing journey for long-distance or city travel. Perfect for weddings, corporate outings, and group tours."
  },
  {
    "name": "AC Luxury Tempo Traveller Pune",
    "description": "AC Luxury Tempo Traveller Pune offers fully air-conditioned premium vehicles for comfortable travel in all seasons. Passengers enjoy a cool and relaxing environment, spacious seating, and smooth rides, making it suitable for family trips, tourist travel, and corporate journeys."
  },
  {
    "name": "Premium Tempo Traveller Pune",
    "description": "Premium Tempo Traveller Pune provides high-end vehicles with superior interiors, comfortable seating, and modern features. Ideal for travelers who value comfort and reliability, this service is suitable for outstation trips, business travel, and luxury group tours."
  },
  {
    "name": "Family Luxury Tempo Traveller Pune",
    "description": "Family Luxury Tempo Traveller Pune is designed to provide safe and comfortable travel for families. With ample seating, luggage space, and smooth driving, it ensures an enjoyable journey for children, adults, and senior citizens on city or outstation trips."
  },
  {
    "name": "Corporate Luxury Tempo Traveller Pune",
    "description": "Corporate Luxury Tempo Traveller Pune caters to business professionals and office groups. Featuring premium interiors, spacious seating, and professional chauffeurs, it ensures punctual and comfortable travel for meetings, conferences, and corporate outings."
  },
  {
    "name": "Wedding Luxury Tempo Traveller Pune",
    "description": "Wedding Luxury Tempo Traveller Pune provides elegant and spacious vehicles for transporting wedding guests in comfort and style. Ideal for ceremonies, receptions, and pre-wedding events, this service ensures smooth coordination and premium travel experience."
  },
  {
    "name": "Outstation Luxury Tempo Traveller Pune",
    "description": "Outstation Luxury Tempo Traveller Pune offers premium vehicles for long-distance travel from Pune. With comfortable seating, air-conditioning, and experienced drivers, passengers enjoy safe, relaxed, and enjoyable journeys to outstation destinations."
  },
  {
    "name": "Affordable Luxury Tempo Traveller Pune",
    "description": "Affordable Luxury Tempo Traveller Pune delivers premium travel comfort at budget-friendly pricing. Ideal for groups seeking luxury without high costs, this service ensures well-maintained vehicles, professional drivers, and transparent pricing."
  },
  {
    "name": "Chauffeur Driven Luxury Tempo Traveller",
    "description": "Chauffeur Driven Luxury Tempo Traveller provides experienced and professional drivers for hassle-free travel. Passengers can relax and enjoy the journey while chauffeurs ensure safety, punctuality, and smooth route management."
  },
  {
    "name": "Group Travel Luxury Tempo Traveller Pune",
    "description": "Group Travel Luxury Tempo Traveller Pune is perfect for large groups traveling together. Spacious interiors, comfortable seating, and coordinated travel make it ideal for corporate groups, family tours, and tourist travel."
  },
  {
    "name": "Best Luxury Tempo Traveller Pune",
    "description": "Best Luxury Tempo Traveller Pune offers top-quality vehicles and reliable service for a superior travel experience. Known for comfort, punctuality, and safety, this option suits families, corporate clients, and luxury travelers."
  },
  {
    "name": "Pune Luxury Tempo Traveller Booking",
    "description": "Pune Luxury Tempo Traveller Booking provides easy and flexible booking options for premium tempo travellers. With transparent pricing, reliable vehicles, and professional service, it ensures convenience for all travel requirements."
  },
  {
    "name": "Tourist Luxury Tempo Traveller Pune",
    "description": "Tourist Luxury Tempo Traveller Pune caters to sightseeing and tourism travel with premium comfort. Ideal for city tours and outstation sightseeing, this service combines luxury interiors, smooth rides, and experienced drivers for memorable travel experiences."
  }
],
"tableData": [
  ["Luxury 12 Seater Tempo Traveller Pune", "Luxury 14 Seater Tempo Traveller Pune"],
  ["Luxury 17 Seater Tempo Traveller Pune", "AC Luxury Tempo Traveller Pune"],
  ["Premium Tempo Traveller Pune", "Family Luxury Tempo Traveller Pune"],
  ["Corporate Luxury Tempo Traveller Pune", "Wedding Luxury Tempo Traveller Pune"],
  ["Outstation Luxury Tempo Traveller Pune", "Affordable Luxury Tempo Traveller Pune"],
  ["Chauffeur Driven Luxury Tempo Traveller", "Group Travel Luxury Tempo Traveller Pune"],
  ["Best Luxury Tempo Traveller Pune", "Pune Luxury Tempo Traveller Booking"],
  ["Tourist Luxury Tempo Traveller Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Luxury 12, 14, 17 Seater Tempo Traveller in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers premium luxury Tempo Travellers in Pune with 12, 14, and 17 seater options, perfect for family trips, corporate travel, group tours, and airport transfers."
  },
  {
    "WhyChooseheading": "Spacious and Luxurious Vehicles",
    "WhyChoosedescription": "Travel in highly comfortable, air-conditioned, and well-maintained luxury Tempo Travellers designed for a smooth and enjoyable journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers are experienced with Pune and nearby routes, ensuring safe, punctual, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for luxury Tempo Traveller rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel planning, and itinerary changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from local, outstation, one-way, round-trip, or customized rental plans tailored for your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All luxury Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for luxury 12, 14, and 17 seater Tempo Traveller rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer luxury 12, 14, and 17 seater Tempo Travellers in Pune?',
    answer: 'Yes, Sanavi Travels provides premium and well-maintained luxury Tempo Travellers in Pune with 12, 14, and 17 seat options.'
  },
  {
    question: 'How can I book a luxury Tempo Traveller in Pune with Sanavi Travels?',
    answer: 'You can easily book through our website or by contacting our 24×7 customer support team.'
  },
  {
    question: 'What seating options are available for luxury Tempo Traveller rentals?',
    answer: 'We offer luxury Tempo Travellers in 12-seater, 14-seater, and 17-seater configurations to suit your group size and travel needs.'
  },
  {
    question: 'Are drivers included with the luxury Tempo Traveller rental?',
    answer: 'Yes, all rentals include experienced and professional drivers.'
  },
  {
    question: 'Can I book a luxury Tempo Traveller for outstation trips?',
    answer: 'Absolutely. Sanavi Travels offers luxury Tempo Traveller rentals for both local and outstation travel.'
  },
  {
    question: 'Are the vehicles sanitized before each trip?',
    answer: 'Yes, all luxury Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Is the luxury Tempo Traveller service available 24×7?',
    answer: 'Yes, our service is available round the clock to match your travel schedule.'
  },
  {
    question: 'What payment options are available for booking?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the trip?',
    answer: 'Yes, our 24×7 customer support team is available throughout your journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Mehta',
    feedback: 'Rented a luxury 17-seater Tempo Traveller from Sanavi Travels in Pune. Very comfortable seats, clean vehicle, and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Great experience with Sanavi Travels. The 14-seater luxury Tempo Traveller was superbly maintained and the driver was very professional.',
    rating: 5
  }
];

































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury 12, 14, 17 Seater Tempo Traveller in Pune - Sanavi Travels",
  "description": "Luxury 12, 14, and 17 Seater Tempo Travellers in Pune by Sanavi Travels for family trips, corporate travel, weddings, outstation tours, and group travel. Choose AC and premium luxury Tempo Travellers for safe, comfortable, and affordable travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1720"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Luxury 12, 14, 17 Seater Tempo Traveller in Pune Starting from ₹35 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book luxury 12, 14, and 17 Seater Tempo Travellers in Pune with Sanavi Travels. AC and premium vehicles for family trips, corporate travel, weddings, outstation tours, and group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxuryontwoseater;